"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorInputState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var bearing_input_state_1 = require("./bearing.input.state");
var distance_input_state_1 = require("./distance.input.state");
var input_state_1 = require("./input.state");
var VectorInputState = /** @class */ (function (_super) {
    tslib_1.__extends(VectorInputState, _super);
    function VectorInputState(label) {
        var _this = _super.call(this, label) || this;
        _this._error = '';
        _this.isLabelShown = false;
        _this.distance = new distance_input_state_1.DistanceInputState('Distance');
        _this.bearing = new bearing_input_state_1.BearingInputState('Bearing');
        return _this;
    }
    Object.defineProperty(VectorInputState.prototype, "value", {
        get: function () {
            if (this.distance.value == null && this.bearing.value == null) {
                return null;
            }
            return {
                bearing: this.bearing.value,
                distance: this.distance.value,
                pitch: this.pitch
            };
        },
        enumerable: false,
        configurable: true
    });
    VectorInputState.equal = function (value1, value2) {
        if (value1 === value2) {
            return true;
        }
        if (value1 == null || value2 == null) {
            return false;
        }
        return distance_input_state_1.DistanceInputState.equal(value1.distance, value2.distance) &&
            bearing_input_state_1.BearingInputState.equal(value1.bearing, value2.bearing) &&
            value1.pitch === value2.pitch;
    };
    VectorInputState.prototype.setValue = function (val) {
        if (val == null) {
            this.distance.setValue(null);
            this.bearing.setValue(null);
            this.pitch = null;
            this.setError(null);
            return;
        }
        this.distance.setValue(val.distance);
        this.bearing.setValue(val.bearing);
        this.pitch = val.pitch;
        if (val.distance == null && val.bearing == null) {
            this.setError(null);
        }
        else if (val.distance == null) {
            this.setError(i18n_1.T.DISTANCE_MISSING);
        }
        else if (val.bearing == null) {
            this.setError(i18n_1.T.BEARING_MISSING);
        }
        else {
            this.setError(null);
        }
    };
    VectorInputState.prototype.hasError = function () {
        return _super.prototype.hasError.call(this) || this.distance.hasError() || this.bearing.hasError();
    };
    Object.defineProperty(VectorInputState.prototype, "error", {
        get: function () {
            // Don't show an error message if one is already being shown
            if (this.distance.hasError() || this.bearing.hasError()) {
                return null;
            }
            if (this.distance.value != null && this.bearing.value == null) {
                return i18n_1.T.BEARING_MISSING;
            }
            if (this.distance.value == null && this.bearing.value != null) {
                return i18n_1.T.DISTANCE_MISSING;
            }
            return this._error;
        },
        set: function (msg) {
            this._error = msg || '';
        },
        enumerable: false,
        configurable: true
    });
    VectorInputState.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.distance.destroy();
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], VectorInputState.prototype, "value", null);
    tslib_1.__decorate([
        mobx_1.action
    ], VectorInputState.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], VectorInputState.prototype, "error", null);
    return VectorInputState;
}(input_state_1.InputState));
exports.VectorInputState = VectorInputState;
//# sourceMappingURL=vector.input.state.js.map